// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3vKjt","list":"BalanceDue_list__2IhJf","listRow":"BalanceDue_listRow__2h-u6","total":"BalanceDue_total__Yw7XQ"};